/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Sync_Changes_From_Linked_GroupInputs */

const en_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync Changes From Linked Group`)
};

const fr_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchroniser les modifications du groupe lié`)
};

const de_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen aus verknüpfter Gruppe synchronisieren`)
};

const it_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizza le modifiche dal gruppo collegato`)
};

const ru_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация изменений из связанной группы`)
};

const es_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar cambios desde un grupo vinculado`)
};

const zh_cn2_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步链接组的更改`)
};

const ja_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクされたグループからの変更を同期`)
};

const hi_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक किए गए समूह से परिवर्तनों को सिंक्रनाइज़ करें`)
};

const pt_pt2_event_group_options_sync_changes_from_linked_group = /** @type {(inputs: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar alterações do grupo vinculado`)
};

/**
* | output |
* | --- |
* | "Sync Changes From Linked Group" |
*
* @param {Event_Group_Options_Sync_Changes_From_Linked_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_sync_changes_from_linked_group = /** @type {((inputs?: Event_Group_Options_Sync_Changes_From_Linked_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Sync_Changes_From_Linked_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_sync_changes_from_linked_group(inputs)
	if (locale === "de") return de_event_group_options_sync_changes_from_linked_group(inputs)
	if (locale === "it") return it_event_group_options_sync_changes_from_linked_group(inputs)
	if (locale === "ru") return ru_event_group_options_sync_changes_from_linked_group(inputs)
	if (locale === "es") return es_event_group_options_sync_changes_from_linked_group(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_sync_changes_from_linked_group(inputs)
	if (locale === "ja") return ja_event_group_options_sync_changes_from_linked_group(inputs)
	if (locale === "hi") return hi_event_group_options_sync_changes_from_linked_group(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_sync_changes_from_linked_group(inputs)
	return en_event_group_options_sync_changes_from_linked_group(inputs)
});